module.exports = __webpack_public_path__ + "static/media/group.1ecbc0ce.svg";